import { useNavigate, useParams } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import {
  useInstallmentPlanTemplateQuery,
  useUpdateInstallmentPlanTemplate,
} from "../api/queries";
import { InstallmentPlanTemplateForm } from "../ui/InstallmentPlanTemplateForm";

export function InstallmentPlanTemplateEditPage() {
  const { id } = useParams({
    from: "/app/performance/installment-plan-templates/$id/edit",
  });
  const nav = useNavigate({
    from: "/app/performance/installment-plan-templates/$id/edit",
  });
  const templateQuery = useInstallmentPlanTemplateQuery(id);
  const updateTemplate = useUpdateInstallmentPlanTemplate(id);

  const template = templateQuery.data;

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            {
              label: "ແມ່ແບບແຜນງວດ",
              to: "/app/performance/installment-plan-templates",
            },
            { label: template?.name ?? "ແກ້ໄຂ" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ແກ້ໄຂແມ່ແບບແຜນງວດ</h2>
          <p className="text-muted-foreground">
            ປັບ % / ວັນຄົບກຳນົດ — ບໍ່ກະທົບແຜນງວດໃນໃບເກັບເງິນທີ່ສ້າງແລ້ວ
          </p>
        </div>

        <div className="rounded-xl border bg-card px-6">
          {templateQuery.isLoading ? (
            <p className="py-8 text-muted-foreground text-sm">ກຳລັງໂຫຼດ...</p>
          ) : !template ? (
            <p className="py-8 text-muted-foreground text-sm">ບໍ່ພົບແມ່ແບບ</p>
          ) : (
            <InstallmentPlanTemplateForm
              initialValues={{
                name: template.name,
                status: template.status,
                sortOrder: template.sortOrder,
                isDefault: template.isDefault,
                rows: template.rows.map((row) => ({
                  installmentNo: row.installmentNo,
                  label: row.label ?? "",
                  labelEn: row.labelEn ?? "",
                  percent: row.percent,
                  dueOffsetDays: row.dueOffsetDays,
                })),
              }}
              onSubmit={async (vals) => {
                try {
                  await updateTemplate.mutateAsync(vals);
                } catch {}
              }}
              onCancel={() =>
                nav({ to: "/app/performance/installment-plan-templates" })
              }
              submitting={updateTemplate.isPending}
            />
          )}
        </div>
      </Main>
    </>
  );
}
